import { styled } from '../../../../../utils/styled';
import { propStyles } from '../../../../../utils/propStyles';

const StyledComponent = styled<any, any>('div', 'toastBase', 'feedback-toast')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '5px',
    height: 'inherit',
    padding: '10px',
    marginBottom: '10px',
    textAlign: 'center',
    position: 'relative',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toast/StyledComponents/ToastBase.tsx